import { render, staticRenderFns } from "./AdUnits.vue?vue&type=template&id=fcdf8c50&scoped=true&"
import script from "./AdUnits.vue?vue&type=script&lang=js&"
export * from "./AdUnits.vue?vue&type=script&lang=js&"
import style0 from "./AdUnits.vue?vue&type=style&index=0&id=fcdf8c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdf8c50",
  null
  
)

export default component.exports